var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Retención " + _vm._s(_vm.numero_comprobante))]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "PPR" && _vm.anulado === "N",
                    expression: "estado === 'PPR' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-warning"
              },
              [_c("strong", [_vm._v("PENDIENTE DE AUTORIZACIÓN")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.anulado === "S",
                    expression: "anulado === 'S'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.estado === null || _vm.estado === undefined) &&
                      _vm.anulado === "N" &&
                      !_vm.enColaAutorizacion,
                    expression:
                      "(estado === null || estado === undefined) && anulado === 'N' && !enColaAutorizacion"
                  }
                ],
                staticClass: "noti-info"
              },
              [_c("strong", [_vm._v("EMITIDO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "AUT" && _vm.anulado === "N",
                    expression: "estado === 'AUT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N" && _vm.anulado === "N",
                    expression: "estado === 'N' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "NAT" && _vm.anulado === "N",
                    expression: "estado === 'NAT' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("NO AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.enColaAutorizacion,
                    expression: "enColaAutorizacion"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_c("strong", [_vm._v("PENDIENTE DE ENVÍO AL SRI")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "layout__controls" },
          [
            _c(
              "button",
              {
                staticClass: "btn-bus200 btn--bigger",
                attrs: {
                  disabled:
                    !_vm.permiteAnularRetencion && !_vm.permiteEditarRetencion,
                  type: "button"
                },
                on: { click: _vm.consultarComprobantes }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Buscar comprobantes")])
              ]
            ),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: {
                  width: "85%",
                  height: "auto",
                  scrollable: "",
                  name: "listaComprobantes"
                }
              },
              [
                _c("lista-comprobantes", {
                  attrs: { tipoComprobante: _vm.tipoComprobanteConsulta },
                  on: { selected: _vm.selectedComprobante }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "###-###-#########",
                                  expression: "'###-###-#########'"
                                }
                              ],
                              attrs: {
                                readonly:
                                  _vm.form.id_tipo_comprobante_afectado !== "",
                                type: "tel",
                                id: "comprobanteAfectado",
                                placeholder: "N° comprobante"
                              },
                              model: {
                                value: _vm.form.numero_comprobante_afectado,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "numero_comprobante_afectado",
                                    $$v
                                  )
                                },
                                expression: "form.numero_comprobante_afectado"
                              }
                            },
                            [
                              _c("span", [_vm._v("Comprobante afectado")]),
                              _vm._v(" "),
                              _vm.errores.numero_comprobante_afectado
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "helper-text text-danger",
                                      attrs: { slot: "helper" },
                                      slot: "helper"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.errores
                                              .numero_comprobante_afectado[0]
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.id_tipo_comprobante_afectado ===
                                    "",
                                  expression:
                                    "form.id_tipo_comprobante_afectado === ''"
                                }
                              ],
                              staticClass: "btn-info",
                              attrs: {
                                disabled: !_vm.editable,
                                type: "button"
                              },
                              on: { click: _vm.consultarComprobantesVenta }
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.id_tipo_comprobante_afectado !==
                                    "",
                                  expression:
                                    "form.id_tipo_comprobante_afectado !== ''"
                                }
                              ],
                              staticClass: "btn-danger",
                              attrs: { disabled: !_vm.editable },
                              on: { click: _vm.quitarComprobanteAfectado }
                            },
                            [_c("i", { staticClass: "fa fa-ban" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "modal",
                            {
                              attrs: {
                                name: "comprobantesAfectados",
                                height: "auto",
                                width: "80%",
                                scrollable: ""
                              }
                            },
                            [
                              _c("lista-comprobantes-compra", {
                                attrs: { tipoComprobante: _vm.codigoFactura },
                                on: { selected: _vm.selectedComprobante }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled:
                              _vm.form.id_tipo_comprobante_afectado !== "",
                            id: "fecha_emision_comprobante_afectado",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_emision_comprobante_afectado,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "fecha_emision_comprobante_afectado",
                                $$v
                              )
                            },
                            expression:
                              "form.fecha_emision_comprobante_afectado"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v("Fecha de emisión del comprobante")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision_comprobante_afectado
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errores
                                        .fecha_emision_comprobante_afectado[0]
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly:
                              _vm.form.id_cliente !== null &&
                              _vm.form.id_cliente !== "",
                            id: "identificacion",
                            placeholder: "# Identificación"
                          },
                          model: {
                            value: _vm.identificacion_cliente,
                            callback: function($$v) {
                              _vm.identificacion_cliente = $$v
                            },
                            expression: "identificacion_cliente"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Identificación *\n                  "
                          ),
                          _vm.errores.id_cliente
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.id_cliente[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.form.id_cliente === null ||
                                  _vm.form.id_cliente === "") &&
                                _vm.form.id_tipo_comprobante_afectado === "" &&
                                _vm.estado === "N",
                              expression:
                                "(form.id_cliente === null || form.id_cliente === '') && form.id_tipo_comprobante_afectado === '' && estado === 'N'"
                            }
                          ],
                          staticClass: "btn-success",
                          attrs: { type: "button" },
                          on: { click: _vm.consultarCliente }
                        },
                        [_c("i", { staticClass: "fa fa-check" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.form.id_cliente !== null &&
                                _vm.form.id_cliente !== "" &&
                                _vm.form.id_tipo_comprobante_afectado === "",
                              expression:
                                "((form.id_cliente !== null && form.id_cliente !== '' && form.id_tipo_comprobante_afectado === ''))"
                            }
                          ],
                          staticClass: "btn-danger",
                          attrs: { type: "button" },
                          on: { click: _vm.quitarCliente }
                        },
                        [_c("i", { staticClass: "fa fa-ban" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "modal",
                        {
                          attrs: {
                            scrollable: "",
                            width: "70%",
                            height: "auto",
                            name: "persona"
                          }
                        },
                        [
                          _c("persona", {
                            attrs: {
                              tipoFiltro: "P",
                              numeroIdentificacion: _vm.identificacion_cliente,
                              searchButton: false
                            },
                            on: { saved: _vm.savedPersona }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: "cliente",
                              placeholder: "Nombre de cliente"
                            },
                            model: {
                              value: _vm.nombre_cliente,
                              callback: function($$v) {
                                _vm.nombre_cliente = $$v
                              },
                              expression: "nombre_cliente"
                            }
                          },
                          [_c("span", [_vm._v("Proveedor *")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.estado === "N" &&
                                  _vm.form.id_tipo_comprobante_afectado === "",
                                expression:
                                  "estado === 'N' && form.id_tipo_comprobante_afectado === ''"
                              }
                            ],
                            staticClass: "btn-info",
                            attrs: { type: "button" },
                            on: { click: _vm.consultarPersonas }
                          },
                          [_c("i", { staticClass: "fa fa-search" })]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: !_vm.editable,
                            id: "email",
                            placeholder: "Correo del cliente"
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v('E-mail ("," para separar varios)')
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-field select2",
                      class: { "select2--disabled": _vm.estado !== "N" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: "descripcion",
                              options: _vm.puntosEmision,
                              id: "punto_emision",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.selectedPuntoEmision,
                              callback: function($$v) {
                                _vm.selectedPuntoEmision = $$v
                              },
                              expression: "selectedPuntoEmision"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "punto_emision" } }, [
                            _vm._v("Punto de emisión")
                          ]),
                          _vm._v(" "),
                          _vm.errores.id_punto_emision
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.id_punto_emision[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.esElectronico && _vm.estado === "N",
                        expression: "!esElectronico && estado === 'N'"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-field" },
                      [
                        _c(
                          "input-field",
                          {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "#########",
                                expression: "'#########'"
                              }
                            ],
                            attrs: {
                              type: "tel",
                              id: "numero_documento",
                              placeholder: "#########"
                            },
                            model: {
                              value: _vm.form.numero_documento,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "numero_documento", $$v)
                              },
                              expression: "form.numero_documento"
                            }
                          },
                          [
                            _c("span", [_vm._v("Número de documento")]),
                            _vm._v(" "),
                            _vm.errores.numero_documento
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "helper-text text-danger",
                                    attrs: { slot: "helper" },
                                    slot: "helper"
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.errores.numero_documento[0])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "fecha_emision",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión (retención)")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            placeholder: "#############",
                            id: "numero_autorizacion"
                          },
                          model: {
                            value: _vm.form.numero_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "numero_autorizacion", $$v)
                            },
                            expression: "form.numero_autorizacion"
                          }
                        },
                        [_c("span", [_vm._v("N° Autorización")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            id: "clave_acceso",
                            placeholder: "################"
                          },
                          model: {
                            value: _vm.clave_acceso,
                            callback: function($$v) {
                              _vm.clave_acceso = $$v
                            },
                            expression: "clave_acceso"
                          }
                        },
                        [_c("span", [_vm._v("Clave de acceso")])]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled: "",
                            id: "fecha_autorizacion",
                            locale: "es",
                            "no-label": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm:ss",
                            formatted: "YYYY-MM-DD HH:mm:ss",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_autorizacion", $$v)
                            },
                            expression: "form.fecha_autorizacion"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_autorizacion" } }, [
                          _vm._v("Fecha de autorización (retención)")
                        ])
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    staticClass: "col-xs-12 col-md-4"
                  },
                  [
                    _c("div", { staticClass: "form-field select2" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("label", { attrs: { for: "tipo_emision" } }, [
                            _vm._v("Tipo de emisión")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              options: _vm.tiposEmision,
                              label: "descripcion",
                              id: "tipo_emision",
                              placeholder: "Seleccione..."
                            },
                            model: {
                              value: _vm.selectedTipoEmision,
                              callback: function($$v) {
                                _vm.selectedTipoEmision = $$v
                              },
                              expression: "selectedTipoEmision"
                            }
                          }),
                          _vm._v(" "),
                          _vm.errores.id_tipo_emision
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.id_tipo_emision[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.no_anular_consumidor_final_aut
                  ? _c("div", { staticClass: "col-xs-12" }, [_vm._m(1)])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("tabla-detalle-retencion", {
                attrs: {
                  disabled: !_vm.editable,
                  codigoIva: _vm.codigoIva,
                  codigoIsd: _vm.codigoIsd,
                  codigoRenta: _vm.codigoRenta,
                  baseImponibleIsd: _vm.baseImponibleIsd,
                  baseImponibleRenta: _vm.baseImponibleRenta,
                  baseImponibleIva: _vm.baseImponibleIva,
                  impuestos: _vm.impuestos,
                  errores: _vm.errores,
                  fechaEmision: _vm.form.fecha_emision,
                  sustentosTributarios: _vm.sustentosTributarios
                },
                on: { input: _vm.inputDetalleRetencion },
                model: {
                  value: _vm.form.detalles,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "detalles", $$v)
                  },
                  expression: "form.detalles"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-informacion-adicional", {
                      attrs: { disabled: !_vm.editable, errores: _vm.errores },
                      model: {
                        value: _vm.form.detallesAdicionales,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "detallesAdicionales", $$v)
                        },
                        expression: "form.detallesAdicionales"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.isd,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalISD"
                              }
                            },
                            [_c("span", [_vm._v("Total ISD")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.iva,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalIva"
                              }
                            },
                            [_c("span", [_vm._v("Total IVA")])]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.renta,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalRenta"
                              }
                            },
                            [_c("span", [_vm._v("Total Renta")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.total,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalRetenido"
                              }
                            },
                            [_c("span", [_vm._v("Total Retenido")])]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "PPR",
                      expression: "estado !== 'PPR'"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      (_vm.estado === "N" && !_vm.permiteCrearRetencion) ||
                      (_vm.estado !== "N" && !_vm.permiteEditarRetencion) ||
                      _vm.enColaAutorizacion,
                    type: "button"
                  },
                  on: { click: _vm.guardarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: {
                    disabled: !_vm.permiteCrearRetencion,
                    type: "button"
                  },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.anulado === "N",
                      expression: "estado !== 'N' && anulado === 'N'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: {
                    disabled: !_vm.permiteAnularRetencion,
                    type: "button"
                  },
                  on: { click: _vm.anularRetencion }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.anulado === "S" &&
                        _vm.estado === "AUT" &&
                        _vm.esElectronico,
                      expression:
                        "anulado === 'S' && estado === 'AUT' && esElectronico"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  attrs: {
                    disabled: !_vm.permiteAnularRetencion,
                    type: "button"
                  },
                  on: { click: _vm.enviarComprobantesAnulados }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar comprobante anulado")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-bus200 btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verAnterior }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-left" }),
                  _vm._v("Anterior\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-primary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.verSiguiente }
                },
                [
                  _c("i", { staticClass: "fa fa-toggle-right" }),
                  _vm._v("Siguiente\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-secondary btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.abrirLogs }
                },
                [
                  _c("i", { staticClass: "fa fa-file-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Logs")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado === "AUT" && _vm.intento_correo,
                      expression: "estado === 'AUT' && intento_correo"
                    }
                  ],
                  staticClass: "btn-dark btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.enviarCorreo }
                },
                [
                  _c("i", { staticClass: "fa fa-envelope-o" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Enviar correo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.estado !== "N" &&
                        (_vm.estado === undefined || _vm.estado === null) &&
                        _vm.anulado === "N" &&
                        !_vm.enColaAutorizacion &&
                        _vm.permiteAutorizarRet,
                      expression:
                        "estado !== 'N' && (estado === undefined || estado === null) && anulado === 'N'  && !enColaAutorizacion && ((permiteAutorizarRet))"
                    }
                  ],
                  staticClass: "btn-primary btn--text",
                  on: { click: _vm.autorizar }
                },
                [
                  _c("i", { staticClass: "fa fa-paper-plane" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Autorizar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-info btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.mostrarAuditorias }
                },
                [
                  _c("i", { staticClass: "fa fa-file" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Auditorías")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "70%",
            name: "coincidenciaComprobantes",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("coincidencia-comprobantes", {
            attrs: { comprobantes: _vm.comprobantesConsultados },
            on: {
              seleccionar: _vm.seleccionarComprobanteAfectado,
              cerrar: function($event) {
                return _vm.$modal.hide("coincidenciaComprobantes")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "listaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { tipoFiltro: "P", filterStatus: false },
            on: { selected: _vm.selectedPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "imprimir",
            height: "auto",
            scrollable: ""
          }
        },
        [_c("imprimir", { attrs: { id_comprobante: _vm.id_comprobante } })],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "50%",
            name: "auditorias",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("auditorias", {
            ref: "auditorias",
            attrs: { id_comprobante: _vm.id_comprobante },
            on: { cancelar: _vm.cancelarAuditorias }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la retención")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noti-info" }, [
      _c("p", [
        _c("i", { staticClass: "fa fa-info-circle" }),
        _vm._v(
          "\n                  Recuerda enviar tus comprobantes electrónicos el mismo día de su emisión para evitar sanciones. según lo establece la resolución NAC-DGERCGC25-00000014.\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Detalles adicionales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf987a54", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf987a54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Retencion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cf987a54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/comprobantes/Retencion.vue
// module chunks = 0